// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3Wc07","row":"Node_row__3IjP6","label":"Node_label__3qHRI","footer":"Node_footer__2OC_E"};